import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { routes } from '~/routes';
import { logOut, showMessage } from '../../actions';
import history from '../../history';
import logoLightFull from '../../images/logos/logoLightFull.svg';
import { Colors } from '../../themes/colors';
import '../../themes/navigation.scss';
import { useInboxCount } from '../Inbox/hooks/useInboxCount';

const MenuTitle = ({ title, isActive }) => (
  <p
    style={{
      fontFamily: 'Nunito',
      fontSize: 18,
      color: Colors.white,
      ...(isActive && {
        fontWeight: 700,
        color: Colors.success_400,
      }),
    }}
  >
    {title}
  </p>
);

export default function TopNavBar({ hasOfficeSelected = true }) {
  const location = useLocation();
  const dispatch = useDispatch();

  const { formattedTotalInbox, totalInbox } = useInboxCount();

  const getHelp = () => {
    if (location.pathname === '/registration') {
      dispatch(
        showMessage({
          title: 'Error',
          message: 'Please finish your registration to access the rest of the platform.',
          isError: true,
        }),
      );
    } else {
      history.push(routes.help);
    }
  };

  const goToInbox = () => {
    if (location.pathname === '/registration') {
      dispatch(
        showMessage({
          title: 'Error',
          message: 'Please finish your registration to access the rest of the platform.',
          isError: true,
        }),
      );
    } else {
      history.push('/dashboard/inbox');
    }
  };

  const goToAccount = () => {
    history.push('/account');
  };

  const getBadgeCount = () => {
    const isTwoDigits = totalInbox > 9;

    if (totalInbox > 0) {
      return (
        <div
          style={{
            borderRadius: 25,
            backgroundColor: Colors.error_500,
            height: 20,
            minWidth: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingLeft: isTwoDigits ? 4 : 0,
            paddingRight: isTwoDigits ? 4 : 0,
          }}
        >
          <span
            style={{
              fontSize: 14,
              fontFamily: 'Nunito',
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            {formattedTotalInbox}
          </span>
        </div>
      );
    }
    return <div />;
  };

  const handleLogout = () => {
    sessionStorage.clear();
    dispatch(logOut());
  };

  return (
    <div className="container">
      <div className="nav_container" style={{ backgroundColor: Colors.primary_500 }}>
        <img
          src={logoLightFull}
          alt="logo_light_full"
          className="logo"
          style={{ cursor: 'pointer', width: 95, marginLeft: 30 }}
          onClick={() => history.push('/')}
        />
        {!location.pathname.includes('registration') ? (
          <div
            style={{
              display: 'flex',
              gap: 36,
              marginRight: 36,
            }}
          >
            {hasOfficeSelected ? (
              <>
                <div
                  data-cy="top-nav-inbox-menu"
                  style={{ cursor: 'pointer' }}
                  onClick={() => goToInbox()}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    <MenuTitle title="Inbox" data-cy="top-nav-inbox-title" isActive={location.pathname === '/dashboard/inbox'} />
                    <div>{getBadgeCount()}</div>
                  </div>
                </div>
                <div
                  data-cy="top-nav-help-menu"
                  style={{ cursor: 'pointer' }}
                  onClick={() => getHelp()}
                >
                  <MenuTitle title="Help" data-cy="top-nav-help-title" isActive={location.pathname === routes.help} />
                </div>
                <div
                  data-cy="top-nav-account-menu"
                  style={{ cursor: 'pointer' }}
                  onClick={() => goToAccount()}
                >
                  <MenuTitle title="Account" data-cy="top-nav-account-title" isActive={location.pathname === '/account'} />
                </div>
              </>
            ) : (
              <div
                data-cy="top-nav-logout-menu"
                style={{ cursor: 'pointer' }}
                onClick={handleLogout}
              >
                <MenuTitle title="Log Out" />
              </div>
            )}
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}
